module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp12_6000.492707e0.png";